import { type FC } from "react";
import { TextField } from "@root/shared/components/TextField";
import { FormItemName } from "@root/shared/components/FormItemName";
import { InformationText } from "@root/shared/components/InformationText";
import { StepCassette } from "../StepCassette";
import * as styles from "./styles.css";
import { headingEmphasis } from "../../styles.css";

type Props = {
  emailValue?: string;
  passwordValue?: string;
  onChangeEmail: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangePassword: (e: React.ChangeEvent<HTMLInputElement>) => void;
  emailErrorMessage?: string;
  passwordErrorMessage?: string;
};

export const Presentation: FC<Props> = ({
  emailValue,
  passwordValue,
  onChangeEmail,
  onChangePassword,
  emailErrorMessage,
  passwordErrorMessage,
}) => (
  <StepCassette
    heading={
      <>
        こちらの入力後に<span className={headingEmphasis}>利用可能</span>となります！
      </>
    }
  >
    <div className={styles.fieldWrapper}>
      <FormItemName labelRequirementType="required">メールアドレス</FormItemName>
      <div className={styles.textFieldWrapper}>
        <TextField
          name="email"
          inputMode="email"
          value={emailValue}
          onChange={onChangeEmail}
          placeholder="例）rejob@relax-job.co.jp"
          hasError={!!emailErrorMessage}
        />
        {emailErrorMessage && (
          <InformationText isAlert text={emailErrorMessage} className={styles.errorMessage} />
        )}
      </div>
    </div>
    <div className={styles.fieldWrapper}>
      <FormItemName labelRequirementType="required">パスワード</FormItemName>
      <p className={styles.passwordInfoText}>
        大文字、小文字、数字、記号から 2種類以上 / 8文字以上
      </p>
      <div className={styles.textFieldWrapper}>
        <TextField
          name="password"
          type="password"
          value={passwordValue}
          onChange={onChangePassword}
          hasError={!!passwordErrorMessage}
        />
        {passwordErrorMessage && (
          <InformationText isAlert text={passwordErrorMessage} className={styles.errorMessage} />
        )}
      </div>
    </div>
  </StepCassette>
);
